import api from '../index';

const baseUrl = '/labourClass';
export const getLaborClassListApi = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-labour-classes`,
  });
};

export const createLaborClassApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/add`,
    data,
  });
};

export const updateLaborClassApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update`,
    data,
  });
};

export const deleteLaborClassApi = (data) => {
  return api({
    method: 'delete',
    url: `${baseUrl}/delete`,
    data,
  });
};
